// constants/pipeline.js
// Created: 2026-03-11 15:30:00 EST
// Updated: 2026-03-11 16:30:00 EST
// Project: Giving Words to Voices
// Author: Michael Schwarz
// Version: 1.0.0
//
// Pipeline constants: stage definitions, status metadata, colours,
// dashboard bucket config, and sort options.

export const PIPELINE_STAGES_FE = [
  { id: 1, label: 'Transcribe',      level: 'part',      optional: false },
  { id: 2, label: 'Translate',       level: 'part',      optional: true  },
  { id: 3, label: 'Review & Mark',   level: 'part',      optional: false },
  { id: 4, label: 'Re-proof',        level: 'part',      optional: true  },
  { id: 5, label: 'Generate Output', level: 'part',      optional: false },
  { id: 6, label: 'QA Review',       level: 'interview', optional: false },
  { id: 7, label: 'Clips & QR',      level: 'interview', optional: true  },
  { id: 8, label: 'Final Review',    level: 'interview', optional: false },
  { id: 9, label: 'Complete',        level: 'interview', optional: false },
];

export const PIPELINE_STATUS_META = {
  pending: { label: 'Pending',     color: '#94a3b8', bg: 'rgba(148,163,184,0.12)' },
  active:  { label: 'In Progress', color: '#f59e0b', bg: 'rgba(245,158,11,0.12)'  },
  done:    { label: 'Done',        color: '#22c55e', bg: 'rgba(34,197,94,0.12)'   },
  skipped: { label: 'Skipped',     color: '#a78bfa', bg: 'rgba(167,139,250,0.12)' },
};

export const STAGE_COLORS = {
  1: { bg: '#007aff' }, 2: { bg: '#5856d6' }, 3: { bg: '#ff9f0a' },
  4: { bg: '#a78bfa' }, 5: { bg: '#32ade6' }, 6: { bg: '#e50914' },
  7: { bg: '#ff6b35' }, 8: { bg: '#34c759' }, 9: { bg: '#22c55e' },
};

export const DASHBOARD_BUCKETS = [
  { key: 'pending',  label: 'Pending',      color: '#94a3b8' },
  { key: 'active',   label: 'In Progress',  color: '#f59e0b' },
  { key: 'review',   label: 'Under Review', color: '#3b82f6' },
  { key: 'complete', label: 'Completed',    color: '#22c55e' },
];

export const DEFAULT_KANBAN_COLUMNS = [
  { key: 'transcription', label: 'Transcription', stages: [1, 2] },
  { key: 'review',        label: 'Review',        stages: [3, 4] },
  { key: 'output',        label: 'Output',        stages: [5] },
  { key: 'qa',            label: 'QA',            stages: [6] },
  { key: 'clips-qr',     label: 'Clips & QR',    stages: [7] },
  { key: 'final-review', label: 'Final Review',   stages: [8] },
  { key: 'complete',      label: 'Complete',       stages: [9] },
];

export function getKanbanColumnForStage(columns, stageId) {
  return columns.find(col => col.stages.includes(stageId)) || columns[columns.length - 1];
}

export const SORT_OPTIONS = [
  { key: 'name',     label: 'Name A–Z'     },
  { key: 'stage',    label: 'Stage'        },
  { key: 'pct',      label: '% Complete'   },
  { key: 'language', label: 'Language'     },
  { key: 'updated',  label: 'Last Updated' },
  { key: 'assignee', label: 'Assignee'     },
];
